export default "__VITE_ASSET__CKKnbxwZ__"